import React, { useContext, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
// import NewCampraLogo from '../Img/camptralogo.png'
import { useNavigate } from "react-router-dom";
import back from "../Img/new home.png";
import AdminImg from "../Img/usrpict.PNG";
// import Viewer from "../Img/user_8777874.png";
import Viewer from "../Img/user.png";
import GrafixImg from "../Img/grapphics.png";
import NotificationImg from "../Img/notification.png";
import HomeIcon from "../Img/icons8-home-20.png";
import DashboardIcon from "../Img/dashboard.png";
import SettingImg from "../Img/settings.png";
import MyArticlesImg from "../Img/my articles.png";
import logoutImg from "../Img/logout.png";
import MangeUserImg from "../Img/manage users.png";
import { CgTranscript, CgLock } from "react-icons/cg";
import VideoTranscriptImg from "../Img/video transcript.png";

// import NotificationCircleImg from '../Img/notification-with-number.png'
import {
  IoIosArrowDown,
  IoIosArrowUp,
  IoIosNotifications,
} from "react-icons/io";
import { useState } from "react";
import GlobalContext from "../context/GlobalContext";
import axios from "axios";
import { API_BASE_URL } from "../utils/config";
// import AiChat from "../Img/AI-chat.png";
import AiChat from "../Img/chat.png";
import DasboardImg from "../Img/dasboard.png";
import Modal from "./Modal";
import TanentUser from "../Img/soap admin.png";
import style from "react-syntax-highlighter/dist/esm/styles/hljs/a11y-dark";

const NewTopNavBar = () => {
  const navigate = useNavigate();
  const rolles = localStorage.getItem("roles");

  const [notificationCircleImg, setNotificationCircleImg] = useState(true);
  const [getTicketStatus, setTicketStatus] = useState(false);
  // const [chatModal, setChatModal] = useState(false)
  const [openPlatform, setOpenPlatform] = useState("");
  const [loading, setLoading] = useState(false);
  const logOutBtn = () => {
    window.KR("remove");
    localStorage.removeItem("jwt_token");
    localStorage.removeItem("tags");
    navigate("/");
    // window.location.reload();
  };
  let bearerToken = localStorage.getItem("jwt_token");
  const config = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };
  const checkTicketStatus = () => {
    axios
      .get(
        `${API_BASE_URL}/wp-json/custom-api/v1/jira?email=${localStorage.getItem(
          "userEmail"
        )}`,
        config
      )
      .then((res) => {
        console.log("line59=", res.data.data);
        if (res.data.data.user_id === "" || res.data.data.user_id === false) {
          setTicketStatus(false);
        } else {
          setTicketStatus(true);
        }
      });
  };
  const {
    logoutModal,
    setLogoutModal,
    setSettingsDropdown,
    settingsDropdown,
    logoUpload,
    notificationCount,
    setNotificationCount,
    chatModal,
    setChatModal,
    showMenu,
    setShowMenu,
  } = useContext(GlobalContext);

  const getTenentData = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        "Content-Type": "multipart/form-data",
        // 'X-Wp-Nonce': '6de9be6ced',
        // 'Content-Type': 'application/json',
      },
    };
    const currentUserId = localStorage.getItem("current_user_Id");
    axios
      .get(`${API_BASE_URL}/wp-json/custom-api/v1/get-data`, config)
      .then((res) => {
        console.log("telentData76=", res.data);
        if (res.data.length > 0) {
          setLoading(true);
          const TenentData = res.data.filter((data) => {
            if (data.tenent_user_id == currentUserId) {
              return data;
            }
          });

          console.log("tenantData=", TenentData);
          if (TenentData.length < 1) {
            alert("You are not Authorized for login please connect to admin.");
            localStorage.removeItem("jwt_token");
            localStorage.removeItem("tags");
            navigate("/");
            window.location.reload();
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (localStorage.getItem("roles") == "editor") {
      getTenentData();
    }
    checkTicketStatus();
  }, [loading]);
  // const updateFavicon = (faviconUrl) => {
  //   const link =
  //     document.querySelector("link[rel*='icon']") ||
  //     document.createElement("link");
  //   link.type = "image/x-icon";
  //   link.rel = "shortcut icon";
  //   link.href = faviconUrl;
  //   document.getElementsByTagName("head")[0].appendChild(link);
  //   const fabIconLink =
  //     document.getElementById("faIconLink") || document.createElement("link");
  //   fabIconLink.id = "fabIconLink";
  //   fabIconLink.rel = "icon";
  //   document.getElementsByTagName("head")[0].appendChild(fabIconLink);
  // };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/wp-json/custom/v1/image`, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("line33=", res);
        localStorage.setItem("logoImg", res.data);
        // updateFavicon(res.data);
      })
      .catch((err) => {
        localStorage.removeItem("jwt_token");
        navigate("/");
      });
  }, [logoUpload]);

  const NewCampraLogo = localStorage.getItem("logoImg");
  const backBtn = () => {
    navigate("/table-posts");
  };
  const uploadUsers = () => {
    navigate("/create-new-user-form");
  };
  const HomeBtn = () => {
    localStorage.removeItem("catagoryId");
    navigate("/all-articles");
  };
  const WigetTable = () => {
    navigate("/widget-admin");
  };
  const manageLog = () => {
    navigate("/logo");
  };
  const manageBroadCast = () => {
    navigate("/broadcast");
  };

  const checkPlatform = () => {
    axios
      .get(`${API_BASE_URL}/wp-json/custom/v1/toggle-option`, config)
      .then((res) => {
        console.log("line399=", res.data);
        setOpenPlatform(res.data.value);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    checkPlatform();
  }, []);

  useEffect(() => {
    // getParentCategories()
    axios
      .get(
        `${API_BASE_URL}/wp-json/custom/v1/get-count/?user_id=${localStorage.getItem(
          "current_user_Id"
        )}`,
        config
      )
      .then((res) => {
        console.log(res);
        setNotificationCount(res.data.count_value);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [notificationCount]);
  const notifications = () => {
    let notification_count = {
      user_id: localStorage.getItem("current_user_Id"),
      count_value: 0,
      reflect_count: "set_count",
    };
    // if (notification_count.user_id != "") {
    // post notification on usermeta start
    axios
      .post(
        `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
        notification_count,
        config
      )
      .then((res) => {
        console.log(res.data);
        setNotificationCount(0);
      })
      .catch((err) => {
        console.log(err);
      });
    // }

    navigate("/notification");
    // setNotificationCircleImg(false)
    // NotificationImg = require('../Img/notification.png')
  };
  const chatModalOpen = () => {
    navigate("/analytics-dashboard");
  };
  return (
    <div className="w-100 ">
      <div
        className="header justify-content-between  main-header"
      // style={{ padding: "0 20px" }}
      >
        <div
          style={{ cursor: "pointer" }}
          className=" left-view header-section"
        >
          <div className="d-flex">
            <div>
              <img
                style={{ width: "100%", height: "65px" }}
                src={GrafixImg}
                alt=""
              />
            </div>
            <div>
              <img
                onClick={() => navigate("/")}
                // width={100}
                // className="commonLogo"
                style={{ width: "100%", height: "65px" }}
                src={NewCampraLogo}
                alt=""
              />
            </div>
          </div>

          {/* <button onClick={CollapseSidbarBtn} className="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0 "><i className="fas fa-bars" ></i></button> */}
        </div>
        <div className="middle-view header-section"></div>
        <div className="right-view header-section">
          {rolles == "administrator" ? (
            <div className="d-flex">
              <div
                onClick={() => {
                  navigate("/default-page");
                }}
                role="button"
                className="manage-users  back-screen "
              >
                {/* Home */}
                <button className="border-0 bg-transparent">
                  <img
                    className="commonLogo"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Home"
                    src={HomeIcon}
                    alt=""
                  />
                </button>
              </div>

              {/* <div className="back-screen ">
                <button onClick={HomeBtn}>
                
                  <img
                    className="commonLogo"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="AI Search"
                   
                    src={AiChat}
                    alt=""
                  />{" "}
                </button>
              </div> */}
              <div
                className="back-screen d-flex flex-column position-relative"
                style={{ backgroundColor: "whitesmoke" }}
              >
                <button
                  className="setting-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    settingsDropdown
                      ? setSettingsDropdown(false)
                      : setSettingsDropdown(true);
                  }}
                >
                  {/* Settings{" "} */}
                  <img
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Setting"
                    src={SettingImg}
                    alt=""
                  />
                  {settingsDropdown ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </button>
                {settingsDropdown && (
                  <div
                    className="d-flex flex-column position-absolute rounded align-items-start"
                    style={{
                      zIndex: "1",
                      top: "40px",
                      backgroundColor: "whitesmoke",
                      width: "max-content",
                    }}
                  >
                    <div
                      onClick={() => navigate("/create-new-user-form")}
                      role="button"
                      className="manage-users p-2 rounded "
                    >
                      Manage users
                    </div>
                    <div
                      onClick={() => navigate("/create-subcategory")}
                      role="button"
                      className="manage-users  p-2 rounded "
                    >
                      Manage Categories
                    </div>
                    <div
                      onClick={() => navigate("/create-tag")}
                      role="button"
                      className="manage-users  p-2 rounded "
                    >
                      Manage Tags
                    </div>
                    <div
                      onClick={WigetTable}
                      role="button"
                      className="manage-users  p-2 rounded "
                    >
                      Manage Widget
                    </div>
                    <div
                      onClick={() => navigate("/login-access")}
                      role="button"
                      className="manage-users p-2 rounded "
                    >
                      Login Tracker
                    </div>
                    <div
                      onClick={manageLog}
                      role="button"
                      className="manage-users  p-2 rounded "
                    >
                      Manage Logo
                    </div>
                    <div
                      onClick={manageBroadCast}
                      role="button"
                      className="manage-users  p-2 rounded "
                    >
                      Manage BroadCast
                    </div>
                    {/* <div onClick={() => { navigate('/log') }} role='button' className='manage-users  p-2 rounded '  >
                                    Log
                                </div> */}
                    {openPlatform != "1" ? (
                      ""
                    ) : (
                      <div
                        onClick={() => {
                          navigate("/manage-open-platform");
                        }}
                        role="button"
                        className="manage-users  p-2 rounded "
                      >
                        Manage Platform
                      </div>
                    )}
                    {/* {
                      getTicketStatus ?

                        <div
                          onClick={() => {
                            navigate("/tickets");
                          }}
                          role="button"
                          className="manage-users  p-2 rounded "
                        >
                          My Tickets
                        </div>
                        : ""} */}
                    {/* <div
                      onClick={() => {
                        navigate("/issue-project");
                      }}
                      role="button"
                      className="manage-users  p-2 rounded "
                    >
                      Tickets Project
                    </div> */}
                    <div
                        onClick={() => {
                          navigate("/tenant-configaration");
                        }}
                        role="button"
                        className="manage-users  p-2 rounded "
                      >
                        Manage Solviya
                      </div>
                    {/* <div
                      onClick={() => {
                        navigate("/transcript");
                      }}
                      role="button"
                      className="manage-users  p-2 rounded "
                    >
                      Transcript
                    </div> */}
                    {/* <div
                      onClick={() => {
                        navigate("/youtube-video-transcript");
                      }}
                      role="button"
                      className="manage-users  p-2 rounded "
                    >
                      YoutubeVideoTranscript
                    </div> */}
                  </div>
                )}
              </div>

              <div className="back-screen">
                <CgTranscript
                  size={20}
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Job Aid generation"
                  onClick={() => {
                    navigate("/create-script");
                  }}
                />
              </div>
              <div className="back-screen">
                <CgLock
                  size={20}
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Manage ticket configuration"
                  onClick={() => {
                    navigate("/manage-credential");
                  }}
                />
              </div>
              <div className="back-screen">

                <img
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Transcript"
                  style={{ width: "20px", cursor: "pointer" }
                  } onClick={() => {

                    navigate("/transcript");
                  }} src={VideoTranscriptImg} alt="" />
              </div>
              {/* <div className="back-screen">
                <button
                  // type="button" className="btn " data-bs-toggle="tooltip" data-bs-placement="top" title="My Articles"
                  onClick={backBtn}
                >
               
                  <img
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="My Articles"
                    src={MyArticlesImg}
                    alt=""
                  />
                </button>
              </div> */}

              {/* <div className="back-screen ">
                <button
                  // data-bs-toggle="modal"
                  // data-bs-target="#exampleModal"
                  onClick={chatModalOpen}
                >
                  <img
                    className="commonLogo"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Dashboard"
                    // width={35}
                    // src={DasboardImg}
                    src={DashboardIcon}
                    alt=""
                  />
                </button>
              </div> */}

              {/* <div className="back-screen notificaion-screen">
                        <button onClick={notifications} className="notification-button">
                            <img src={NotificationImg} data-bs-toggle="tooltip" data-bs-placement="top" title="Notification" alt="" className="notification-icon" />
                            {notificationCount > 0 && <div className="notification-count">{notificationCount}</div>}
                        </button>
                    </div> */}

              <div className="user-det position-relative">
                <div className="usr-bac ">
                  {/* <button className="border-0 bg-transparent">
                    <img
                      src={Viewer}
                     
                      alt=""
                    />
                  </button> */}

                  <button className="border-0 bg-transparent">
                    <div
                      className="user-avatar"
                      style={{
                        width: "35px",
                        height: "35px",
                        borderRadius: "50%",
                        backgroundColor: "#ccc",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    // title={`${localStorage.getItem("display_name")}`} // To show full name on hover
                    >
                      {localStorage
                        .getItem("display_name")
                        .charAt(0)
                        .toUpperCase()}
                      {/* Custom tooltip */}
                      <div className="custom-tooltip">
                        <p
                          id="usrname"
                          style={{ margin: 0, fontWeight: "bold" }}
                        >
                          {localStorage.getItem("display_name")}
                        </p>
                        <p id="usrrole" style={{ margin: 0, color: "#888" }}>
                          Admin
                        </p>
                      </div>
                    </div>
                  </button>
                  <div>
                    {/* className="user-name d-flex" */}
                    {/* <div>
                      <p id="usrname">{localStorage.getItem("display_name")}</p>
                      <p id="usrrole">Admin</p>
                    </div> */}
                    <div>
                      {logoutModal ? (
                        <IoIosArrowUp
                          role="button"
                          onClick={() => setLogoutModal(false)}
                        />
                      ) : (
                        <IoIosArrowDown
                          role="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            setLogoutModal(true);
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
                {logoutModal && (
                  <div
                    className="p-2 position-absolute rounded text-center"
                    style={{
                      zIndex: "1",
                      // border: "1px solid",
                      left: "35px",
                      top: "40px",
                      // transform: translateX("-80%"),
                      // transform
                      // width: "100%",
                      // background: "white",
                      cursor: "pointer",
                      // backgroundColor: "rgb(204, 204, 204)",
                    }}
                  >
                    {/* <span
                      className="text-danger"
                      onClick={logOutBtn}
                      role="button"
                    >
                      Logout
                    </span> */}
                    <img
                      style={{
                        padding: "2px",
                        backgroundColor: "rgb(204, 204, 204)",
                      }}
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="Logout"
                      onClick={logOutBtn}
                      role="button"
                      src={logoutImg}
                      alt=""
                    />
                  </div>
                )}
              </div>
            </div>
          ) : rolles == "author" ? (
            <div className="d-flex">
              {/* {alert(rolles)} */}
              <div
                onClick={() => {
                  navigate("/default-page");
                }}
                role="button"
                className="manage-users  back-screen "
              >
                {/* Home */}
                <button className="border-0 bg-transparent">
                  <img
                    className="commonLogo"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Home"
                    src={HomeIcon}
                    alt=""
                  />
                </button>
              </div>
              <div className="back-screen ">
                <button onClick={HomeBtn}>
                  {/* Home */}
                  <img
                    className="commonLogo"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="AI Search"
                    // width={40}
                    src={AiChat}
                    alt=""
                  />{" "}
                </button>
              </div>

              <div
                className="back-screen d-flex flex-column position-relative"
                style={{ backgroundColor: "whitesmoke" }}
              >
                <button
                  className="setting-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    settingsDropdown
                      ? setSettingsDropdown(false)
                      : setSettingsDropdown(true);
                  }}
                >
                  <img
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Setting"
                    src={SettingImg}
                    alt=""
                  />
                  {settingsDropdown ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </button>
                {settingsDropdown && (
                  <div
                    className="d-flex flex-column position-absolute rounded"
                    style={{
                      zIndex: "1",
                      top: "40px",
                      backgroundColor: "whitesmoke",
                      width: "max-content",
                    }}
                  >
                    <div
                      onClick={() => navigate("/create-subcategory")}
                      role="button"
                      className="manage-users  p-2 rounded "
                    >
                      Manage Categories
                    </div>
                    {/* <div
                    onClick={() => {
                      navigate("/manage-open-platform");
                    }}
                    role="button"
                    className="manage-users  p-2 rounded "
                  >
                    Manage Platform
                  </div> */}
                  </div>
                )}
              </div>

              {/* <div className="back-screen">
                <CgTranscript
                  size={20}
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="TestScript generation"
                  onClick={() => {
                    navigate("/create-script");
                  }}
                />
              </div> */}
              <div className="back-screen">
                <CgLock
                  size={20}
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Manage ticket configuration"
                  onClick={() => {
                    navigate("/manage-credential");
                  }}
                />
              </div>
              <div className="back-screen">
                <button
                  // type="button" className="btn " data-bs-toggle="tooltip" data-bs-placement="top" title="My Articles"
                  onClick={backBtn}
                >

                  <img
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="My Articles"
                    src={MyArticlesImg}
                    alt=""
                  />
                </button>
              </div>
              <div className="back-screen ">
                <button
                  // data-bs-toggle="modal"
                  // data-bs-target="#exampleModal"
                  onClick={chatModalOpen}
                >
                  <img
                    className="commonLogo"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Dashboard"
                    // width={35}
                    src={DashboardIcon}
                    alt=""
                  />
                </button>
              </div>
              {/* <div className="back-screen notificaion-screen">
                                <button onClick={notifications} className="notification-button">
                                    <img src={NotificationImg} data-bs-toggle="tooltip" data-bs-placement="top" title="Notification" alt="" className="notification-icon" />
                                    {notificationCount > 0 && <div className="notification-count">{notificationCount}</div>}
                                </button>
                            </div> */}
              <div className="user-det position-relative">
                <div className="usr-bac ">
                  {/* <button className="border-0 bg-transparent">
                    <img
                      src={Viewer}
                     
                      alt=""
                    />
                  </button> */}

                  <button className="border-0 bg-transparent">
                    <div
                      className="user-avatar"
                      style={{
                        width: "35px",
                        height: "35px",
                        borderRadius: "50%",
                        backgroundColor: "#ccc",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    // title={`${localStorage.getItem("display_name")}`} // To show full name on hover
                    >
                      {localStorage
                        .getItem("display_name")
                        .charAt(0)
                        .toUpperCase()}
                      {/* Custom tooltip */}
                      <div className="custom-tooltip">
                        <p
                          id="usrname"
                          style={{ margin: 0, fontWeight: "bold" }}
                        >
                          {localStorage.getItem("display_name")}
                        </p>
                        <p id="usrrole" style={{ margin: 0, color: "#888" }}>
                          Author
                        </p>
                      </div>
                    </div>
                  </button>
                  <div>
                    {/* className="user-name d-flex" */}
                    {/* <div>
                      <p id="usrname">{localStorage.getItem("display_name")}</p>
                      <p id="usrrole">Admin</p>
                    </div> */}
                    <div>
                      {logoutModal ? (
                        <IoIosArrowUp
                          role="button"
                          onClick={() => setLogoutModal(false)}
                        />
                      ) : (
                        <IoIosArrowDown
                          role="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            setLogoutModal(true);
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
                {logoutModal && (
                  <div
                    className="p-2 position-absolute rounded text-center"
                    style={{
                      zIndex: "1",
                      // border: "1px solid",
                      left: "35px",
                      top: "40px",
                      // transform: translateX("-80%"),
                      // transform
                      // width: "100%",
                      // background: "white",
                      cursor: "pointer",
                      // backgroundColor: "rgb(204, 204, 204)",
                    }}
                  >
                    {/* <span
                      className="text-danger"
                      onClick={logOutBtn}
                      role="button"
                    >
                      Logout
                    </span> */}
                    <img
                      style={{
                        padding: "2px",
                        backgroundColor: "rgb(204, 204, 204)",
                      }}
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="Logout"
                      onClick={logOutBtn}
                      role="button"
                      src={logoutImg}
                      alt=""
                    />
                  </div>
                )}
              </div>
            </div>
          ) : rolles == "editor" ? (
            <div className="d-flex">
              <div
                onClick={() => {
                  navigate("/default-page");
                }}
                role="button"
                className="manage-users  back-screen "
              >
                {/* Home */}
                <button className="border-0 bg-transparent">
                  <img
                    className="commonLogo"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Home"
                    src={HomeIcon}
                    alt=""
                  />
                </button>
              </div>

              <div className="back-screen ">
                <button onClick={HomeBtn}>
                  {/* Home */}
                  <img
                    className="commonLogo"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="AI Search"
                    // width={40}
                    src={AiChat}
                    alt=""
                  />
                </button>
              </div>

              {/* <div className="back-screen">
                <CgTranscript
                  size={20}
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="TestScript generation"
                  onClick={() => {
                    navigate("/create-script");
                  }}
                />
              </div> */}
              {/* <div
                onClick={() => navigate("/create-subcategory")}
                role="button"
                className="manage-users  p-2 rounded "
              >
                Manage Categories
              </div> */}
              <div className="back-screen">
                <CgLock
                  size={20}
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Manage ticket configuration"
                  onClick={() => {
                    navigate("/manage-credential");
                  }}
                />
              </div>

              <div
                className="back-screen d-flex flex-column position-relative"
                style={{ backgroundColor: "whitesmoke" }}
              >
                <button
                  className="setting-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    settingsDropdown
                      ? setSettingsDropdown(false)
                      : setSettingsDropdown(true);
                  }}
                >
                  {/* Settings{" "} */}
                  <img
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Setting"
                    src={SettingImg}
                    alt=""
                  />
                  {settingsDropdown ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </button>
                {settingsDropdown && (
                  <div
                    className="d-flex flex-column position-absolute rounded align-items-start"
                    style={{
                      zIndex: "1",
                      top: "40px",
                      backgroundColor: "whitesmoke",
                      width: "max-content",
                    }}
                  >
                    <div
                      onClick={() => navigate("/create-new-user-form")}
                      role="button"
                      className="manage-users p-2 rounded "
                    >
                      Manage users
                    </div>
                    <div
                      onClick={() => navigate("/create-subcategory")}
                      role="button"
                      className="manage-users  p-2 rounded "
                    >
                      Manage Categories
                    </div>
                    <div
                      onClick={() => navigate("/create-tag")}
                      role="button"
                      className="manage-users  p-2 rounded "
                    >
                      Manage Tags
                    </div>


                    <div
                      onClick={manageLog}
                      role="button"
                      className="manage-users  p-2 rounded "
                    >
                      Manage Logo
                    </div>

                    {/* <div
                      onClick={() => {
                        navigate("/issue-project");
                      }}
                      role="button"
                      className="manage-users  p-2 rounded "
                    >
                      Tickets Project
                    </div> */}
                  </div>
                )}
              </div>
              {/* <div
                onClick={() => navigate("/create-new-user-form")}
                role="button"
                className="manage-users p-2 rounded "
              >
                Manage users
              </div> */}
              {/* <div className="back-screen ">
                <button
                  // data-bs-toggle="modal"
                  // data-bs-target="#exampleModal"
                  onClick={() => navigate("/create-new-user-form")}
                >
                  <img
                    className="commonLogo"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Manage users"
                    // width={35}
                    src={MangeUserImg}
                    alt=""
                  />
                </button>
              </div> */}
              {showMenu ? (
                <div className="back-screen ">
                  <button
                    // data-bs-toggle="modal"
                    // data-bs-target="#exampleModal"
                    onClick={chatModalOpen}
                  >
                    <img
                      className="commonLogo"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Dashboard"
                      // width={35}
                      src={DashboardIcon}
                      alt=""
                    />
                  </button>
                </div>
              ) : (
                ""
              )}
              {showMenu ? (
                <div
                  onClick={() => {
                    navigate("/widget-installation-guide");
                  }}
                  role="button"
                  className="back-screen"
                >
                  <img
                    // className="commonLogo"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Widget"
                    // width={35}
                    src={TanentUser}
                    alt=""
                  />
                </div>
              ) : (
                ""
              )}
              <div className="back-screen">
                <button
                  // type="button" className="btn " data-bs-toggle="tooltip" data-bs-placement="top" title="My Articles"
                  onClick={backBtn}
                >
                  {/* <img src={myarticles} alt="" style={{ width: '40px', height: '40px' }} /> */}
                  {/* My Articles */}
                  <img
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="My Articles"
                    src={MyArticlesImg}
                    alt=""
                  />
                </button>
              </div>
              {/* <div className="back-screen notificaion-screen">
                                <button onClick={notifications} className="notification-button">
                                    <img src={NotificationImg} data-bs-toggle="tooltip" data-bs-placement="top" title="Notification" alt="" className="notification-icon" />
                                    {notificationCount > 0 && <div className="notification-count">{notificationCount}</div>}
                                </button>
                            </div> */}

              <div className="user-det position-relative">
                <div className="usr-bac ">
                  {/* <button className="border-0 bg-transparent">
                    <img
                      src={Viewer}
                     
                      alt=""
                    />
                  </button> */}

                  <button className="border-0 bg-transparent">
                    <div
                      className="user-avatar"
                      style={{
                        width: "35px",
                        height: "35px",
                        borderRadius: "50%",
                        backgroundColor: "#ccc",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    // title={`${localStorage.getItem("display_name")}`} // To show full name on hover
                    >
                      {localStorage
                        .getItem("display_name")
                        .charAt(0)
                        .toUpperCase()}
                      {/* Custom tooltip */}
                      <div className="custom-tooltip">
                        <p
                          id="usrname"
                          style={{ margin: 0, fontWeight: "bold" }}
                        >
                          {localStorage.getItem("display_name")}
                        </p>
                        <p id="usrrole" style={{ margin: 0, color: "#888" }}>
                          Tenant Admin
                        </p>
                      </div>
                    </div>
                  </button>
                  <div>
                    {/* className="user-name d-flex" */}
                    {/* <div>
                      <p id="usrname">{localStorage.getItem("display_name")}</p>
                      <p id="usrrole">Admin</p>
                    </div> */}
                    <div>
                      {logoutModal ? (
                        <IoIosArrowUp
                          role="button"
                          onClick={() => setLogoutModal(false)}
                        />
                      ) : (
                        <IoIosArrowDown
                          role="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            setLogoutModal(true);
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
                {logoutModal && (
                  <div
                    className="p-2 position-absolute rounded text-center"
                    style={{
                      zIndex: "1",
                      // border: "1px solid",
                      left: "35px",
                      top: "40px",
                      // transform: translateX("-80%"),
                      // transform
                      // width: "100%",
                      // background: "white",
                      cursor: "pointer",
                      // backgroundColor: "rgb(204, 204, 204)",
                    }}
                  >
                    {/* <span
                      className="text-danger"
                      onClick={logOutBtn}
                      role="button"
                    >
                      Logout
                    </span> */}
                    <img
                      style={{
                        padding: "2px",
                        backgroundColor: "rgb(204, 204, 204)",
                      }}
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="Logout"
                      onClick={logOutBtn}
                      role="button"
                      src={logoutImg}
                      alt=""
                    />
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="d-flex">
              <div
                onClick={() => {
                  navigate("/default-page");
                }}
                role="button"
                className="manage-users  back-screen "
              >
                {/* Home */}
                <button className="border-0 bg-transparent">
                  <img
                    className="commonLogo"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Home"
                    src={HomeIcon}
                    alt=""
                  />
                </button>
              </div>
              <div
                style={{ cursor: "pointer" }}
                className="border-0 back-screen  "
                onClick={HomeBtn}
              >
                {/* Home */}
                <img
                  className="commonLogo"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="AI Search"
                  // width={40}
                  src={AiChat}
                  alt=""
                />
              </div>

              {/* <div className="back-screen">
                <CgTranscript
                  size={20}
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="TestScript generation"
                  onClick={() => {
                    navigate("/create-script");
                  }}
                />
              </div> */}
              <div className="back-screen">
                <CgLock
                  size={20}
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Manage ticket configuration"
                  onClick={() => {
                    navigate("/manage-credential");
                  }}
                />
              </div>
              <div className="back-screen ">
                <button
                  // data-bs-toggle="modal"
                  // data-bs-target="#exampleModal"
                  onClick={chatModalOpen}
                >
                  <img
                    className="commonLogo"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Dashboard"
                    // width={35}
                    src={DashboardIcon}
                    alt=""
                  />
                </button>
              </div>
              {/* <div className="back-screen notificaion-screen">
              <button onClick={notifications} className="notification-button">
                <img
                  src={NotificationImg}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Notification"
                  alt=""
                  className="notification-icon"
                />
                {notificationCount > 0 && (
                  <div className="notification-count">{notificationCount}</div>
                )}
              </button>
            </div> */}

              <div className="user-det position-relative">
                <div className="usr-bac ">
                  {/* <button className="border-0 bg-transparent">
                    <img
                      src={Viewer}
                     
                      alt=""
                    />
                  </button> */}

                  <button className="border-0 bg-transparent">
                    <div
                      className="user-avatar"
                      style={{
                        width: "35px",
                        height: "35px",
                        borderRadius: "50%",
                        backgroundColor: "#ccc",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    // title={`${localStorage.getItem("display_name")}`} // To show full name on hover
                    >
                      {localStorage
                        .getItem("display_name") ? localStorage
                          .getItem("display_name")
                          .charAt(0)
                          .toUpperCase() : ""}
                      {/* Custom tooltip */}
                      <div className="custom-tooltip">
                        <p
                          id="usrname"
                          style={{ margin: 0, fontWeight: "bold" }}
                        >
                          {localStorage.getItem("display_name")}
                        </p>
                        <p id="usrrole" style={{ margin: 0, color: "#888" }}>
                          Reader
                        </p>
                      </div>
                    </div>
                  </button>
                  <div>
                    {/* className="user-name d-flex" */}
                    {/* <div>
                      <p id="usrname">{localStorage.getItem("display_name")}</p>
                      <p id="usrrole">Admin</p>
                    </div> */}
                    <div>
                      {logoutModal ? (
                        <IoIosArrowUp
                          role="button"
                          onClick={() => setLogoutModal(false)}
                        />
                      ) : (
                        <IoIosArrowDown
                          role="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            setLogoutModal(true);
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
                {logoutModal && (
                  <div
                    className="p-2 position-absolute rounded text-center"
                    style={{
                      zIndex: "1",
                      // border: "1px solid",
                      left: "35px",
                      top: "40px",
                      // transform: translateX("-80%"),
                      // transform
                      // width: "100%",
                      // background: "white",
                      cursor: "pointer",
                      // backgroundColor: "rgb(204, 204, 204)",
                    }}
                  >
                    {/* <span
                      className="text-danger"
                      onClick={logOutBtn}
                      role="button"
                    >
                      Logout
                    </span> */}
                    <img
                      style={{
                        padding: "2px",
                        backgroundColor: "rgb(204, 204, 204)",
                      }}
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="Logout"
                      onClick={logOutBtn}
                      role="button"
                      src={logoutImg}
                      alt=""
                    />
                  </div>
                )}
              </div>
            </div>
          )}
          <Modal />
        </div>
      </div>
    </div>
  );
};

export default NewTopNavBar;
